<template>
  <table class="wallet-table">
    <thead>
      <tr>
        <th class="px-2 py-3">
          <div class="row"></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="i in 10"
        :key="i"
      >
        <td class="px-2 py-3">
          <div class="row"></div>
        </td>
      </tr>
    </tbody>
  </table>
  <div
    class="mt-4 flex flex-col justify-center gap-3 md:flex-row md:justify-between md:items-center"
  >
    <p class="w-48 h-4 bg-bg-primary animate-pulse rounded-lg mx-auto"></p>
    <p
      class="w-11/12 h-9 bg-bg-primary animate-pulse rounded-lg md:w-3/5 mx-auto md:mr-0"
    ></p>
  </div>
</template>

<style scoped lang="scss">
.row {
  @apply bg-bg-primary animate-pulse h-5 rounded-md lg:h-6;
}
</style>
